import React, { useEffect, useState } from 'react';
import Head from '../../layout/head/Head';
import Content from '../../layout/content/Content';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, Col, DataTableHead, DataTableItem, DataTableRow, Icon, PreviewAltCard, Row } from '../../components/Component';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import CardTabs from '../components/cards/CardTabs';
import AuthTenantNoData from '../error/AuthTenantNoData';
import AuthTenantPageError from '../error/AuthTenantPageError';
import AuthTenantLoader from '../loaders/AuthTenantLoader';
import { ADMIN_ADD_EMPLOYEE_TO_TENANT_API, ADMIN_RETRIEVE_TENANT_DETAILS_API, ADMIN_RETRIEVE_TENANT_EMPLOYEES_LIST_API, ADMIN_UPDATE_TENANT_EMAIL_CREDENTIALS_API, ADMIN_UPDATE_TENANT_LOGO_API, ADMIN_UPDATE_TENANT_SMS_CREDENTIALS_API, ADMIN_RETRIEVE_TENANT_PROFILE_ROLES_API } from '../../api/api_data';
import { ADD_EMPLOYEE_TO_TENANT_ERROR_MSG, ADD_EMPLOYEE_TO_TENANT_SUCCESS_MSG, RETRIVE_SPECIFIC_TENANT_DETAILS_ERROR_MSG, RETRIVE_SPECIFIC_TENANT_DETAILS_SUCCESS_MSG, RETRIVE_SPECIFIC_TENANT_SETTINGS_ERROR_MSG, RETRIVE_TENANT_PROFILE_ROLES_ERROR_MSG, RETRIVE_TENANT_PROFILE_ROLES_SUCCESS_MSG, RETRIVE_TENANT_PROFILES_LIST_ERROR_MSG, RETRIVE_TENANT_PROFILES_LIST_SUCCESS_MSG, UPDATE_TENANT_EMAIL_CREDENTIALS_ERROR_MSG, UPDATE_TENANT_EMAIL_CREDENTIALS_SUCCESS_MSG, UPDATE_TENANT_LOGO_ERROR_MSG, UPDATE_TENANT_LOGO_SUCCESS_MSG, UPDATE_TENANT_SMS_CREDENTIALS_ERROR_MSG, UPDATE_TENANT_SMS_CREDENTIALS_SUCCESS_MSG } from '../../utils/error_success_messages';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { fail_retrieve_specific_tenant_settings, loading_retrieve_specific_tenant_settings, reset_retrieve_specific_tenant_settings, success_retrieve_specific_tenant_settings } from '../../reducers/auth_tenant/retrieve_specific_tenant_settings_Slice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import * as app_consts from "../../utils/app_consts";
import { formatToSentenceCase, messageToast } from '../../utils/Utils';
import { Alert, Badge, Card, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { fail_update_tenant_logo, loading_update_tenant_logo, reset_update_tenant_logo, success_update_tenant_logo } from '../../reducers/auth_tenant/update_tenant_logo_Slice';
import { fail_update_tenant_sms_credentials, loading_update_tenant_sms_credentials, reset_update_tenant_sms_credentials, success_update_tenant_sms_credentials } from '../../reducers/auth_tenant/update_tenant_sms_credentials_Slice';
import { fail_update_tenant_email_credentials, loading_update_tenant_email_credentials, reset_update_tenant_email_credentials, success_update_tenant_email_credentials } from '../../reducers/auth_tenant/update_tenant_email_credentials_Slice';
import TextInput from '../components/inputs/TextInput';
import { fail_retrieve_tenant_profiles_list, loading_retrieve_tenant_profiles_list, reset_retrieve_tenant_profiles_list, success_retrieve_tenant_profiles_list } from '../../reducers/auth_tenant/retrieve_tenant_profiles_list_Slice';
import moment from 'moment';
import { fail_retrieve_tenant_profile_roles, loading_retrieve_tenant_profile_roles, reset_retrieve_tenant_profile_roles, success_retrieve_tenant_profile_roles } from '../../reducers/auth_tenant/retrieve_tenant_profile_roles_Slice';
import { fail_add_employee_to_tenant, loading_add_employee_to_tenant, reset_add_employee_to_tenant, success_add_employee_to_tenant } from '../../reducers/auth_tenant/add_employee_to_tenant_Slice';
import PhoneInput from 'react-phone-input-2';
import AdminTenantModules from './AdminTenantModules';
import AdminViewTenantBulkSMSPortalModal from '../../components/modal/data/admin/AdminViewTenantBulkSMSPortalModal';

const initial_state = { tenant_logo: "", id: "" };
const email_provider_inital_state = { email_address: "", email_provider: "", password: "", id: "" };
const sms_provider_inital_state = { sms_provider: "", sms_sender_id: "", password: "", id: "" };
const initalAddEmployeeState = { first_name: "", last_name: "", mobile_number: "", email_address: "", roles: [], position: "", department: "" };

const AdminTenantDetails = ({ tenant_info, user_info }) => {

  const [page_data, setPageData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { id } = useParams();
  const [activeCardTab, setActiveCardTab] = useState("Main Info");
  const dispatch = useDispatch();
  const [upload_logo_modal, setUploadImageLogo] = useState(false);
  const [upload_logo_loading, setUploadLogoLoading] = useState();
  const [upload_logo_error, setUploadLogoError] = useState("");
  const [logo_settings, setLogoSettings] = useState([]);
  const [email_provider_settings, setEmailProviderSettings] = useState([]);
  const [email_provider_modal, setEmailProviderModal] = useState(false);
  const [email_provider_error, setEmailProviderError] = useState("");
  const [email_provider_loading, setEmailProiver_loading] = useState(false);
  const [email_provider_formData, setEmailProviderFormData] = useState(email_provider_inital_state);
  const [sms_provider_settings, setSmsProviderSettings] = useState([]);
  const [sms_provider_modal, setSmsProviderModal] = useState(false);
  const [sms_provider_error, setSmsProviderError] = useState("");
  const [sms_provider_loading, setSmsProiver_loading] = useState(false);
  const [sms_provider_formData, setSmsProviderFormData] = useState(sms_provider_inital_state);
  const [employees_loading, setEmployeesLoading] = useState(true);
  const [employees_error, setEmployeesError] = useState("");
  const [employee_data, setEmployeeData] = useState([]);
  const [currentEmployeeData, setCurrentEmployeeData] = useState([]);
  const [currentEmployeePage, setCurrentEmployeePage] = useState(1);
  const [employeePerPage] = useState(10);
  const [sm, updateSm] = useState(false);
  const [employeSearchTerm, setEmployeeSearchTerm] = useState("");
  const [add_employee_modal, setAddEmployeeModal] = useState(false);
  const [add_employee_error, setAddEmployeeError] = useState("");
  const [add_employee_loading, setAddEmployeeLoading] = useState(false);
  const [add_employee_formData, setAddEmployeeFormData] = useState(initalAddEmployeeState);
  const [tenant_profile_roles, setTenantProfileRoles] = useState([]);
  const [bulk_sms_portal_settings, setBulkSMSSettings] = useState([]);
  const [bulk_sms_portal, setBulkSMSPortal] = useState(false);
  const [formData, setFormData] = useState(initial_state);

  const open_bulk_sms_portal = () => {
    setBulkSMSPortal(true);
  };

  const close_bulk_sms_portal = () => {
    setBulkSMSPortal(false);
  };

  const bulk_sms_portal_successFunction = () => {
    retrieve_tenant_details();
  };

  useEffect(() => {
    retrieve_tenant_details();
  }, []);

  const retrieve_tenant_details = () => {

    dispatch(tenant_auth_actions_helper(loading_retrieve_specific_tenant_settings, success_retrieve_specific_tenant_settings, fail_retrieve_specific_tenant_settings, RETRIVE_SPECIFIC_TENANT_DETAILS_ERROR_MSG, RETRIVE_SPECIFIC_TENANT_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${ADMIN_RETRIEVE_TENANT_DETAILS_API}/${id}`));

    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_profiles_list, success_retrieve_tenant_profiles_list, fail_retrieve_tenant_profiles_list, RETRIVE_TENANT_PROFILES_LIST_ERROR_MSG, RETRIVE_TENANT_PROFILES_LIST_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${ADMIN_RETRIEVE_TENANT_EMPLOYEES_LIST_API}/${id}`));

  };

  // Listener
  const retrieve_specific_tenant_settings_listener = useSelector((state) => state.retrieve_specific_tenant_settings.retrieve_specific_tenant_settings);

  useEffect(() => {
    if (retrieve_specific_tenant_settings_listener.status !== app_consts.IDLE)
    {
      if (retrieve_specific_tenant_settings_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        setLoading(false);
        if (retrieve_specific_tenant_settings_listener.status === app_consts.FAIL)
        {
          setError(retrieve_specific_tenant_settings_listener.message);
          messageToast(retrieve_specific_tenant_settings_listener.message, app_consts.FAIL);
        } else if (retrieve_specific_tenant_settings_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_specific_tenant_settings_listener.data);
          // Filter Logo Settings
          const filtered_logo_settings = retrieve_specific_tenant_settings_listener.data?.tenant_settings?.find((setting) => setting?.name === app_consts.TENANT_LOGO);
          const filtered_email_provider_settings = retrieve_specific_tenant_settings_listener.data?.tenant_settings?.find((setting) => setting?.name === app_consts.TENANT_EMAIL_PROVIDER);
          const filtered_sms_provider_settings = retrieve_specific_tenant_settings_listener.data?.tenant_settings?.find((setting) => setting?.name === app_consts.TENANT_SMS_PROVIDER);
          const filtered_bulk_sms_portal_settings = retrieve_specific_tenant_settings_listener.data?.tenant_settings?.find((setting) => setting?.name === app_consts.BULK_SMS_PORTAL);

          if (filtered_logo_settings)
          {
            setLogoSettings(filtered_logo_settings);
          }
          if (filtered_email_provider_settings)
          {
            setEmailProviderSettings(filtered_email_provider_settings);
          }
          if (filtered_sms_provider_settings)
          {
            setSmsProviderSettings(filtered_sms_provider_settings);
          }
          if (filtered_sms_provider_settings)
          {
            setBulkSMSSettings(filtered_bulk_sms_portal_settings);
          }

          setFormData({ ...formData, ["id"]: id });
          setEmailProviderFormData({ ...formData, ["id"]: id });
          setSmsProviderFormData({ ...formData, ["id"]: id });

        }
        dispatch(reset_retrieve_specific_tenant_settings());
      }
    }
  }, [retrieve_specific_tenant_settings_listener]);

  // Listener
  const retrieve_tenant_profiles_list_listener = useSelector((state) => state.retrieve_tenant_profiles_list.retrieve_tenant_profiles_list);

  useEffect(() => {
    if (retrieve_tenant_profiles_list_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_profiles_list_listener.status === app_consts.LOADING)
      {
        setEmployeesLoading(true);
        setEmployeesError("");
      } else
      {
        setEmployeesLoading(false);
        if (retrieve_tenant_profiles_list_listener.status === app_consts.FAIL)
        {
          setEmployeesError(retrieve_tenant_profiles_list_listener.message);
          messageToast(retrieve_tenant_profiles_list_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_profiles_list_listener.status === app_consts.SUCCESS)
        {
          setEmployeeData(retrieve_tenant_profiles_list_listener.data);
          setCurrentEmployeeData(retrieve_tenant_profiles_list_listener.data);
        }
        dispatch(reset_retrieve_tenant_profiles_list());
      }
    }
  }, [retrieve_tenant_profiles_list_listener]);

  // Card Tabs
  const tabs = [
    {
      tabName: "Main Info"
    },
    {
      tabName: "Configuration"
    },
    {
      tabName: "Audit Trails"
    },
    {
      tabName: "Employees"
    },
    {
      tabName: "Modules"
    }
  ];

  const open_upload_logo_modal = () => {
    setUploadImageLogo(true);
  };

  const close_upload_logo_modal = () => {
    setUploadImageLogo(false);
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];

    if (file)
    {
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];

      if (!allowedTypes.includes(file.type))
      {
        messageToast("Please select a valid image file (PNG, JPEG, JPG.", app_consts.FAIL);
        return;
      }

      setFormData({ ...formData, ["tenant_logo"]: file });
    }
  };


  const handle_logo_submit = () => {
    setUploadLogoError("");
    // Update
    const sent_logo = { tenant_logo: formData?.tenant_logo, id: formData?.id };

    dispatch(tenant_auth_actions_helper(loading_update_tenant_logo, success_update_tenant_logo, fail_update_tenant_logo, UPDATE_TENANT_LOGO_ERROR_MSG, UPDATE_TENANT_LOGO_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${ADMIN_UPDATE_TENANT_LOGO_API}`, sent_logo));
  };

  // Listener
  const update_tenant_logo_listener = useSelector((state) => state.update_tenant_logo.update_tenant_logo);

  useEffect(() => {
    if (update_tenant_logo_listener.status !== app_consts.IDLE)
    {
      if (update_tenant_logo_listener.status === app_consts.LOADING)
      {
        setUploadLogoLoading(true);
        setUploadLogoError("");
      } else
      {
        setUploadLogoLoading(false);
        if (update_tenant_logo_listener.status === app_consts.FAIL)
        {
          setUploadLogoError(update_tenant_logo_listener.message);
          messageToast(update_tenant_logo_listener.message, app_consts.FAIL);
        } else if (update_tenant_logo_listener.status === app_consts.SUCCESS)
        {

          retrieve_tenant_details();
          setUploadLogoError("");
          setFormData({ ...formData, ["tenant_logo"]: "" });
          setUploadImageLogo(false);
        }
        dispatch(reset_update_tenant_logo());
      }
    }
  }, [update_tenant_logo_listener]);



  const open_email_provider_modal = () => {
    setEmailProviderModal(true);
    setEmailProviderError("");
    setSmsProviderFormData({ ...email_provider_formData, ["email_provider"]: email_provider_settings?.settings?.email_provider, ["email_address"]: email_provider_settings?.settings?.email_address, ["password"]: "" });

  };

  const close_email_provider_modal = () => {
    setEmailProviderModal(false);
    setEmailProviderError("");
    setEmailProviderFormData({ ...email_provider_formData, ["email_provider"]: "", ["email_address"]: "", ["password"]: "" });

  };

  const handleUpdateEmailCredentials = () => {
    setEmailProviderError("");

    dispatch(tenant_auth_actions_helper(loading_update_tenant_email_credentials, success_update_tenant_email_credentials, fail_update_tenant_email_credentials, UPDATE_TENANT_EMAIL_CREDENTIALS_ERROR_MSG, UPDATE_TENANT_EMAIL_CREDENTIALS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${ADMIN_UPDATE_TENANT_EMAIL_CREDENTIALS_API}`, email_provider_formData));
  };

  // Listener
  const update_tenant_email_credentials_listener = useSelector((state) => state.update_tenant_email_credentials.update_tenant_email_credentials);

  useEffect(() => {
    if (update_tenant_email_credentials_listener.status !== app_consts.IDLE)
    {
      if (update_tenant_email_credentials_listener.status === app_consts.LOADING)
      {
        setEmailProiver_loading(true);
        setEmailProviderError("");
      } else
      {
        setEmailProiver_loading(false);
        if (update_tenant_email_credentials_listener.status === app_consts.FAIL)
        {
          setEmailProviderError(update_tenant_email_credentials_listener.message);
          messageToast(update_tenant_email_credentials_listener.message, app_consts.FAIL);
        } else if (update_tenant_email_credentials_listener.status === app_consts.SUCCESS)
        {
          messageToast(update_tenant_email_credentials_listener.message, app_consts.SUCCESS);
          retrieve_tenant_details();
          close_email_provider_modal();
        }
        dispatch(reset_update_tenant_email_credentials());
      }
    }
  }, [update_tenant_email_credentials_listener]);


  const open_sms_provider_modal = () => {
    setSmsProviderModal(true);
    setSmsProviderError("");
    setSmsProviderFormData({ ...sms_provider_formData, ["sms_provider"]: sms_provider_formData?.settings?.sms_provider, ["sms_sender_id"]: sms_provider_formData?.settings?.sms_sender_id, ["password"]: "" });

  };

  const close_sms_provider_modal = () => {
    setSmsProviderModal(false);
    setSmsProviderError("");
    setSmsProviderFormData({ ...sms_provider_formData, ["sms_provider"]: "", ["sms_sender_id"]: "", ["password"]: "" });

  };

  const handleUpdateSmsCredentials = () => {
    setSmsProviderError("");

    dispatch(tenant_auth_actions_helper(loading_update_tenant_sms_credentials, success_update_tenant_sms_credentials, fail_update_tenant_sms_credentials, UPDATE_TENANT_SMS_CREDENTIALS_ERROR_MSG, UPDATE_TENANT_SMS_CREDENTIALS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${ADMIN_UPDATE_TENANT_SMS_CREDENTIALS_API}`, sms_provider_formData));
  };
  // Listener
  const update_tenant_sms_credentials_listener = useSelector((state) => state.update_tenant_sms_credentials.update_tenant_sms_credentials);

  useEffect(() => {
    if (update_tenant_sms_credentials_listener.status !== app_consts.IDLE)
    {
      if (update_tenant_sms_credentials_listener.status === app_consts.LOADING)
      {
        setSmsProiver_loading(true);
        setSmsProviderError("");
      } else
      {
        setSmsProiver_loading(false);
        if (update_tenant_sms_credentials_listener.status === app_consts.FAIL)
        {
          setSmsProviderError(update_tenant_sms_credentials_listener.message);
          messageToast(update_tenant_sms_credentials_listener.message, app_consts.FAIL);
        } else if (update_tenant_sms_credentials_listener.status === app_consts.SUCCESS)
        {
          messageToast(update_tenant_sms_credentials_listener.message, app_consts.SUCCESS);
          retrieve_tenant_details();
          close_sms_provider_modal();
        }
        dispatch(reset_update_tenant_sms_credentials());
      }
    }
  }, [update_tenant_sms_credentials_listener]);

  // Get current list, pagination
  const indexOfLastEmployee = currentEmployeePage * employeePerPage;
  const indexOfFirstEmployee = indexOfLastEmployee - employeePerPage;
  const currentEmployees = currentEmployeeData?.slice(indexOfFirstEmployee, indexOfLastEmployee);

  const employee_paginate = (pageNumber) => setCurrentEmployeePage(pageNumber);

  // Calculate the start and end index for the current page
  const employeeStartIndex = (currentEmployeePage - 1) * employeePerPage;
  const employeeEndIndex = employeeStartIndex + employeePerPage;

  // UseEffect for Search 
  useEffect(() => {
    filtered_employees(employeSearchTerm);
  }, [employeSearchTerm]);

  const filtered_employees = (searchItem) => {
    if (searchItem)
    {
      let displayedEmployees;

      displayedEmployees = employee_data?.filter((item) => {
        const combinedParams = [
          item?.user?.first_name,
          item?.user?.first_name ? `${item?.user?.first_name} ${item?.user?.last_name}` : "--",
          item?.user?.last_name,
          item?.account?.mobile_number,
          item?.account?.email_address,
          item.department,
          item.position,
          item.department,
          item.department,
          item?.profile?.inserted_at ? moment(item?.profile?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--",
          item?.last_login ? moment(item?.last_login).format("YYYY-MM-DD HH:mm:ss") : "--",
          item.status?.replace(/_/g, ' ').toUpperCase(),
        ]
          .join(" ")
          .toLowerCase();

        return combinedParams.includes(searchItem.toLowerCase());
      }).slice(employeeStartIndex, employeeEndIndex);

      setCurrentEmployeeData(displayedEmployees);
    } else
    {
      setCurrentEmployeeData(employee_data);
    }
  };

  // Open Add Employee Modal
  const open_add_employee_modal = () => {
    setAddEmployeeFormData(initalAddEmployeeState);
    setAddEmployeeModal(true);
    setAddEmployeeError("");
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_profile_roles, success_retrieve_tenant_profile_roles, fail_retrieve_tenant_profile_roles, RETRIVE_TENANT_PROFILE_ROLES_ERROR_MSG, RETRIVE_TENANT_PROFILE_ROLES_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${ADMIN_RETRIEVE_TENANT_PROFILE_ROLES_API}`));
  };

  // Listener
  const retrieve_tenant_profile_roles_listener = useSelector((state) => state.retrieve_tenant_profile_roles.retrieve_tenant_profile_roles);

  useEffect(() => {
    if (retrieve_tenant_profile_roles_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_profile_roles_listener.status === app_consts.LOADING)
      {
        console.log("Tenant Profile Roles Loading");
      } else
      {
        if (retrieve_tenant_profile_roles_listener.status === app_consts.FAIL)
        {
          messageToast(retrieve_tenant_profile_roles_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_profile_roles_listener.status === app_consts.SUCCESS)
        {
          setTenantProfileRoles(retrieve_tenant_profile_roles_listener.data);
        }
        dispatch(reset_retrieve_tenant_profile_roles());
      }
    }
  }, [retrieve_tenant_profile_roles_listener]);

  const close_add_employee_modal = () => {
    setAddEmployeeModal(false);
    setAddEmployeeError("");

  };

  const handleAddEmployeeChange = (e) => {
    setAddEmployeeFormData({ ...add_employee_formData, [e.target.name]: e.target.value });
  };

  const handleSubmitAddEmployee = () => {
    setAddEmployeeError("");
    const new_form_data = { ...add_employee_formData, id: id };
    dispatch(tenant_auth_actions_helper(loading_add_employee_to_tenant, success_add_employee_to_tenant, fail_add_employee_to_tenant, ADD_EMPLOYEE_TO_TENANT_ERROR_MSG, ADD_EMPLOYEE_TO_TENANT_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${ADMIN_ADD_EMPLOYEE_TO_TENANT_API}`, new_form_data));
  };
  // Listener
  const add_employee_to_tenant_listener = useSelector((state) => state.add_employee_to_tenant.add_employee_to_tenant);

  useEffect(() => {
    if (add_employee_to_tenant_listener.status !== app_consts.IDLE)
    {
      if (add_employee_to_tenant_listener.status === app_consts.LOADING)
      {
        setAddEmployeeLoading(true);
        setAddEmployeeError("");
      } else
      {
        if (add_employee_to_tenant_listener.status === app_consts.FAIL)
        {
          setAddEmployeeError(add_employee_to_tenant_listener.message, app_consts.FAIL);
          messageToast(add_employee_to_tenant_listener.message, app_consts.FAIL);
        } else if (add_employee_to_tenant_listener.status === app_consts.SUCCESS)
        {
          close_add_employee_modal();
          retrieve_tenant_details();
        }
        setAddEmployeeLoading(false);
        dispatch(reset_add_employee_to_tenant());
      }
    }
  }, [add_employee_to_tenant_listener]);

  const handleAddEmployeeRowChange = (role) => {
    let new_roles = add_employee_formData?.roles || [];

    if (new_roles?.includes(role))
    {
      new_roles = new_roles?.filter((ro) => ro !== role);
    } else
    {
      new_roles.push(role); // Just push the role without re-assigning to new_roles
    }

    setAddEmployeeFormData({ ...add_employee_formData, roles: new_roles });
  };

  return (
    <>
      <Head title="Tenant Details" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween className="g-3">
            <BlockHeadContent>
              <BlockTitle page>Tenant Details {page_data?.tenant?.name && ` - ${page_data?.tenant?.name}`}</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <Link to={`${process.env.PUBLIC_URL}/tenants`}>
                <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                  <Icon name="arrow-left"></Icon>
                  <span>Back</span>
                </Button>
              </Link>
              <Link to={`${process.env.PUBLIC_URL}/tenants`}>
                <Button color="light" outline className="btn-icon bg-white d-inline-flex d-sm-none">
                  <Icon name="arrow-left"></Icon>
                </Button>
              </Link>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
        </Block>
        {
          loading ?
            <>
              <AuthTenantLoader tenant_info={tenant_info} />
            </>
            :
            <>
              {
                error ?
                  <>
                    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                  </>
                  :
                  <>
                    {
                      page_data ?
                        <>
                          {
                            activeCardTab === "Main Info" && (
                              <>
                                <PreviewAltCard>
                                  <Row className="pb-5">
                                    <Col lg={6}>
                                      {
                                        logo_settings?.settings?.logo_url ? (
                                          <>
                                            <Card className="product-card" style={{ height: "350px" }}>
                                              <div
                                                className="product-thumb"
                                                style={{
                                                  height: '350px',
                                                  display: 'flex',
                                                  justifyContent: 'center',
                                                  alignItems: 'center',
                                                  backgroundColor: '#f9f9f9',
                                                  border: '1px dashed #ccc',
                                                }}
                                              >
                                                <img
                                                  src={logo_settings?.settings?.logo_url}
                                                  alt="Logo"
                                                  style={{
                                                    maxHeight: '90%', // Keeps it inside the box
                                                    maxWidth: '90%',
                                                    objectFit: 'contain',
                                                    display: 'block',
                                                  }}
                                                />
                                              </div>
                                            </Card>
                                            <div className="mt-4 d-flex justify-content-end">
                                              <Button color="primary" size="md" onClick={open_upload_logo_modal}>
                                                Update Logo
                                              </Button>
                                            </div>
                                          </>
                                        ) : (
                                          <Card className="product-card" style={{ height: '100%' }}>
                                            <div className="product-thumb" style={{ height: '100%' }}>
                                              <div style={{
                                                width: '100%',
                                                height: '100%',  // Take 100% of the container height
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                backgroundColor: '#f0f0f0', // Light gray background
                                                textAlign: 'center',
                                                border: '1px dashed #ccc', // Dashed border to simulate placeholder
                                                fontSize: '18px', // Font size
                                                fontWeight: 'bold', // Make the text bold
                                                fontFamily: 'Arial, sans-serif', // Custom font
                                                flexDirection: "column"
                                              }}>
                                                <div style={{
                                                  display: 'flex',
                                                  justifyContent: 'center',
                                                  alignItems: 'center',
                                                  textAlign: 'center',
                                                  color: '#333', // Text color
                                                  fontSize: '18px', // Font size
                                                  fontWeight: 'bold', // Make the text bold
                                                  fontFamily: 'Arial, sans-serif', // Custom font
                                                }}>
                                                  <p style={{ margin: 0, padding: '5px' }}>YOUR</p>
                                                  <p style={{ margin: 0, padding: '5px' }}>LOGO</p>
                                                  <p style={{ margin: 0, padding: '5px' }}>HERE</p>
                                                </div>
                                                <Button color="primary" size="md" onClick={open_upload_logo_modal}>
                                                  Upload Logo
                                                </Button>
                                              </div>
                                            </div>
                                          </Card>
                                        )
                                      }
                                    </Col>
                                    <Col lg={6}>
                                      <form className="gy-3 form-settings">
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label" htmlFor="site-name">
                                                Name
                                              </label>
                                              <span className="form-note">Name to be used through out the System</span>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <input disabled type="text" className="form-control" id="site-name" defaultValue={page_data?.tenant?.name} />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Website URL</label>
                                              <span className="form-note">URL to Access the System</span>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="site-url"
                                                  defaultValue={`${process.env.PUBLIC_URL}/${page_data?.tenant?.url_prefix}`}
                                                  disabled
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Email Address</label>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="site-url"
                                                  defaultValue={page_data?.tenant?.email_address}
                                                  disabled
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Mobile Number</label>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="site-url"
                                                  defaultValue={page_data?.tenant?.mobile_number}
                                                  disabled
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <div className="mt-4 ">
                                          <BlockHead>
                                            <BlockTitle tag="h6">Contact Details</BlockTitle>
                                          </BlockHead>
                                        </div>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Name</label>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="site-url"
                                                  defaultValue={page_data?.user?.first_name ? `${page_data?.user?.first_name} ${page_data?.user?.last_name}` : "--"}
                                                  disabled
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Email Address</label>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="site-url"
                                                  defaultValue={page_data?.account?.email_address || "--"}
                                                  disabled
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Mobile Number</label>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="site-url"
                                                  defaultValue={page_data?.account?.mobile_number || "--"}
                                                  disabled
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      </form>
                                    </Col>
                                  </Row>
                                </PreviewAltCard>
                                <Modal isOpen={upload_logo_modal} className="modal-dialog-centered" size={"lg"}>
                                  <ModalHeader toggle={!upload_logo_loading && close_upload_logo_modal}>Upload Logo</ModalHeader>
                                  <ModalBody>
                                    <div className="product-thumb" style={{ height: '250px', width: '100%', position: 'relative' }}>
                                      {formData.tenant_logo ? (
                                        <>
                                          <img
                                            src={URL.createObjectURL(formData.tenant_logo)}
                                            alt="Uploaded Logo"
                                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                          />
                                        </>
                                      ) : (
                                        <label htmlFor="imageUpload" style={{
                                          width: '100%',
                                          height: '100%',
                                          display: 'flex',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          backgroundColor: '#f0f0f0',
                                          textAlign: 'center',
                                          border: '1px dashed #ccc',
                                          fontSize: '18px',
                                          fontWeight: 'bold',
                                          fontFamily: 'Arial, sans-serif',
                                          flexDirection: "column",
                                          cursor: 'pointer'
                                        }}>
                                          <p style={{ margin: 0, padding: '5px' }}>Click to Select Image</p>
                                        </label>
                                      )}

                                      <input
                                        type="file"
                                        id="imageUpload"
                                        accept="image/png, image/jpeg, image/jpg"
                                        style={{ display: 'none' }}
                                        onChange={handleImageUpload}
                                      />
                                    </div>

                                    {upload_logo_error && (
                                      <div className="mb-3 w-100 mt-4">
                                        <Alert color="danger" className="alert-icon">
                                          <Icon name="alert-circle" /> {upload_logo_error}{" "}
                                        </Alert>
                                      </div>
                                    )}
                                    <div className={`d-flex flex-row ${formData?.tenant_logo ? "justify-content-between" : "justify-content-end"} mt-4`}>
                                      {
                                        formData?.tenant_logo && (
                                          <>
                                            <Button color="primary" size="md" onClick={open_upload_logo_modal}>
                                              Re-upload
                                            </Button>
                                          </>
                                        )
                                      }
                                      <Button color="success" size="md" onClick={handle_logo_submit} disabled={!formData?.tenant_logo}>
                                        {upload_logo_loading ? "Uploading Logo..." : "Upload Logo"}
                                      </Button>
                                    </div>
                                  </ModalBody>
                                </Modal>
                              </>
                            )
                          }
                          {
                            activeCardTab === "Configuration" && (
                              <>
                                <Block className='my-3'>
                                  <Row className="g-gs">
                                    <Col xxl="6" key={module.id}>
                                      <div className="nk-download">
                                        <div className="data">
                                          <div className="thumb">
                                            <Icon name="emails" style={{ fontSize: "32px" }} />
                                          </div>
                                          <div className="info">
                                            <h6 className="title">
                                              <span className="name">Emailing Service</span>{" "}
                                            </h6>
                                            <div className="meta">
                                              <span className="version">
                                                <span className="text-soft">Email Provider: </span> <span>{email_provider_settings?.settings?.email_provider || "Not Set"}</span>
                                              </span>
                                              <span className="release">
                                                <span className="text-soft">Email Address: </span> <span>{email_provider_settings?.settings?.email_address || "Not Set"}</span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="actions">
                                          <Button onClick={open_email_provider_modal} color={email_provider_settings?.email_provider ? "Active" : "primary"}>
                                            Update
                                          </Button>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xxl="6" key={module.id}>
                                      <div className="nk-download">
                                        <div className="data">
                                          <div className="thumb">
                                            <Icon name="emails" style={{ fontSize: "32px" }} />
                                          </div>
                                          <div className="info">
                                            <h6 className="title">
                                              <span className="name">Bulk SMS Service</span>{" "}
                                            </h6>
                                            <div className="meta">
                                              <span className="version">
                                                <span className="text-soft">SMS Provider: </span> <span>{sms_provider_settings?.settings?.sms_provider || "Not Set"}</span>
                                              </span>
                                              <span className="release">
                                                <span className="text-soft">Sender ID: </span> <span>{sms_provider_settings?.settings?.sms_sender_id || "Not Set"}</span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="actions">
                                          <Button onClick={open_sms_provider_modal} color={sms_provider_formData?.sms_provider ? "Active" : "primary"}>
                                            Update
                                          </Button>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xxl="6" key={module.id}>
                                      <div className="nk-download">
                                        <div className="data">
                                          <div className="thumb">
                                            <Icon name="emails" style={{ fontSize: "32px" }} />
                                          </div>
                                          <div className="info">
                                            <h6 className="title">
                                              <span className="name">Bulk SMS Portal</span>{" "}
                                            </h6>
                                            <div className="meta">
                                              <span className="version">
                                                <span className="text-soft">Status: </span> <span>{bulk_sms_portal_settings ? "SET" : "Not Set"}</span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="actions">
                                          <Button onClick={open_bulk_sms_portal} color="primary">
                                            View
                                          </Button>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Block>

                                <AdminViewTenantBulkSMSPortalModal tenant_info={tenant_info} user_info={user_info} data={page_data} isOpen={bulk_sms_portal} closeModal={close_bulk_sms_portal} successFunction={bulk_sms_portal_successFunction} />

                                <Modal isOpen={email_provider_modal} className="modal-dialog-centered" size={"md"}>
                                  <ModalHeader toggle={!email_provider_loading && close_email_provider_modal}>Update Email Provider Settings</ModalHeader>
                                  <ModalBody>
                                    <Row className="g-4">
                                      <TextInput
                                        label="Email Address"
                                        type="email"
                                        required
                                        id_val="email_provider_email_address"
                                        value={email_provider_formData?.email_address}
                                        colSize="6"
                                        name="email_provider_email_address"
                                        handleChange={(e) => setEmailProviderFormData({ ...email_provider_formData, ["email_address"]: e.target.value })}
                                      />
                                      <TextInput
                                        label="Email Provider"
                                        type="text"
                                        required
                                        id_val="email_provider_email_provider"
                                        value={email_provider_formData?.email_provider}
                                        colSize="6"
                                        name="email_provider_email_provider"
                                        handleChange={(e) => setEmailProviderFormData({ ...email_provider_formData, ["email_provider"]: e.target.value })}
                                      />
                                      <TextInput
                                        label="Password"
                                        type="password"
                                        required
                                        id_val="email_provider_password"
                                        value={email_provider_formData?.password}
                                        colSize="6"
                                        name="email_provider_password"
                                        handleChange={(e) => setEmailProviderFormData({ ...email_provider_formData, ["password"]: e.target.value })}
                                      />
                                      {email_provider_error && (
                                        <div className="mb-3 w-100">
                                          <Alert color="danger" className="alert-icon">
                                            <Icon name="alert-circle" /> {email_provider_error}{" "}
                                          </Alert>
                                        </div>
                                      )}
                                      <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                                        <Button
                                          onClick={handleUpdateEmailCredentials}
                                          disabled={email_provider_loading ||
                                            !(email_provider_formData?.email_address?.trim() &&
                                              email_provider_formData?.email_provider?.trim() &&
                                              email_provider_formData?.password?.trim())}
                                          color="primary"
                                        >
                                          {email_provider_loading ? <Spinner size="sm" color="light" /> : "Update Email Credentials"}
                                        </Button>
                                      </Col>
                                    </Row>
                                  </ModalBody>
                                </Modal>

                                <Modal isOpen={sms_provider_modal} className="modal-dialog-centered" size={"md"}>
                                  <ModalHeader toggle={!sms_provider_loading && close_sms_provider_modal}>Update Bulk SMS Provider Settings</ModalHeader>
                                  <ModalBody>
                                    <Row className="g-4">
                                      <TextInput
                                        label="SMS Provider"
                                        type="text"
                                        required
                                        id_val="sms_provider"
                                        value={sms_provider_formData?.sms_provider}
                                        colSize="6"
                                        name="sms_provider"
                                        handleChange={(e) => setSmsProviderFormData({ ...sms_provider_formData, ["sms_provider"]: e.target.value })}
                                      />
                                      <TextInput
                                        label="Sender ID"
                                        type="text"
                                        required
                                        id_val="sms_sender_id"
                                        value={sms_provider_formData?.sms_sender_id}
                                        colSize="6"
                                        name="sms_sender_id"
                                        handleChange={(e) => setSmsProviderFormData({ ...sms_provider_formData, ["sms_sender_id"]: e.target.value })}
                                      />
                                      <TextInput
                                        label="API Key"
                                        type="password"
                                        required
                                        id_val="sender_api_key"
                                        value={sms_provider_formData?.password}
                                        colSize="6"
                                        name="sender_api_key"
                                        handleChange={(e) => setSmsProviderFormData({ ...sms_provider_formData, ["password"]: e.target.value })}
                                      />
                                      {email_provider_error && (
                                        <div className="mb-3 w-100">
                                          <Alert color="danger" className="alert-icon">
                                            <Icon name="alert-circle" /> {email_provider_error}{" "}
                                          </Alert>
                                        </div>
                                      )}
                                      <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                                        <Button
                                          onClick={handleUpdateSmsCredentials}
                                          disabled={sms_provider_loading ||
                                            !(sms_provider_formData?.sms_provider?.trim() &&
                                              sms_provider_formData?.sms_sender_id?.trim() &&
                                              sms_provider_formData?.password?.trim())}
                                          color="primary"
                                        >
                                          {sms_provider_loading ? <Spinner size="sm" color="light" /> : "Update SMS Credentials"}
                                        </Button>
                                      </Col>
                                    </Row>
                                  </ModalBody>
                                </Modal>


                              </>
                            )
                          }
                          {
                            activeCardTab === "Employees" && (
                              <>
                                <BlockHead size="sm">
                                  <BlockBetween>
                                    <BlockHeadContent>
                                      <BlockTitle page>Employees</BlockTitle>
                                      <BlockDes className="text-soft">
                                        <p>{!(employees_loading || employees_error) && `Employees ${currentEmployeeData?.length}`}</p>
                                      </BlockDes>
                                      {!(employees_loading) && (
                                        <div className="mt-2">
                                          <Link
                                            onClick={(e) => {
                                              e.preventDefault();
                                              retrieve_tenant_details();
                                            }}
                                          >
                                            <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                                              <span>Refresh List</span>
                                            </Button>
                                          </Link>
                                        </div>
                                      )}
                                    </BlockHeadContent>
                                    <BlockHeadContent>
                                      <div className="toggle-wrap nk-block-tools-toggle">
                                        <a
                                          href="#more"
                                          className="btn btn-icon btn-trigger toggle-expand me-n1"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                            updateSm(!sm);
                                          }}
                                        >
                                          <Icon name="more-v"></Icon>
                                        </a>
                                        <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                                          <ul className="nk-block-tools g-3">
                                            <li>
                                              <div className="form-control-wrap">
                                                <div className="form-icon form-icon-right">
                                                  <Icon name="search"></Icon>
                                                </div>
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  id="default-04"
                                                  value={employeSearchTerm}
                                                  // onChange={e => setSearchTerm(e.target.value)}
                                                  placeholder="Search for Employees"
                                                />
                                              </div>
                                            </li>
                                            {
                                              (user_info?.roles?.includes(app_consts.ADMINISTRATOR) || user_info?.roles?.includes(app_consts.ADD_EMPLOYEE_PROFILE)) && (
                                                <>
                                                  <li className="nk-block-tools-opt">
                                                    <Button
                                                      className="toggle btn-icon d-md-none"
                                                      color="primary"
                                                      onClick={() => {
                                                        open_add_employee_modal();
                                                      }}
                                                    >
                                                      <Icon name="plus"></Icon>
                                                    </Button>
                                                    <Button
                                                      className="toggle d-none d-md-inline-flex"
                                                      color="primary"
                                                      onClick={() => {
                                                        open_add_employee_modal();
                                                      }}
                                                    >
                                                      <Icon name="plus"></Icon>
                                                      <span>Add Employee</span>
                                                    </Button>
                                                  </li>
                                                </>
                                              )
                                            }
                                          </ul>
                                        </div>
                                      </div>
                                    </BlockHeadContent>
                                  </BlockBetween>
                                </BlockHead>
                                {
                                  employees_loading ?
                                    <>
                                      <AuthTenantLoader tenant_info={tenant_info} />
                                    </>
                                    :
                                    <>
                                      {
                                        employees_error ?
                                          <>
                                            <AuthTenantPageError tenant_info={tenant_info} error_message={employees_error} />
                                          </>
                                          :
                                          <>
                                            {
                                              employee_data ?
                                                <>
                                                  <Block>
                                                    <div className="nk-tb-list is-separate is-medium mb-3">
                                                      <DataTableHead className="nk-tb-item">
                                                        <DataTableRow>
                                                          <span className="sub-text">Username</span>
                                                        </DataTableRow>
                                                        <DataTableRow size="mb">
                                                          <span className="sub-text">Department</span>
                                                        </DataTableRow>
                                                        <DataTableRow size="md">
                                                          <span className="sub-text">Position</span>
                                                        </DataTableRow>
                                                        <DataTableRow size="lg">
                                                          <span className="sub-text">Date Created</span>
                                                        </DataTableRow>
                                                        <DataTableRow size="lg">
                                                          <span className="sub-text">Last Login</span>
                                                        </DataTableRow>
                                                        <DataTableRow size="md">
                                                          <span className="sub-text">Status</span>
                                                        </DataTableRow>
                                                        <DataTableRow size="md">
                                                          <span className="sub-text">Action</span>
                                                        </DataTableRow>
                                                      </DataTableHead>
                                                      {/*Head*/}
                                                      {currentEmployees.length > 0
                                                        ? currentEmployees.map((item) => (
                                                          <DataTableItem key={item.id}>
                                                            <DataTableRow>
                                                              <Link to={`#`}>
                                                                <div className="user-card">
                                                                  <div className="user-info">
                                                                    <span className="tb-lead">
                                                                      {item?.user?.first_name ? `${item?.user?.first_name} ${item?.user?.last_name}` : "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                                                    </span>
                                                                    <span>{item?.account?.email_address || "--"}  | {item?.account?.mobile_number || "--"} </span>
                                                                  </div>
                                                                </div>
                                                              </Link>
                                                            </DataTableRow>
                                                            <DataTableRow>
                                                              <span>{item?.profile?.department}</span>
                                                            </DataTableRow>
                                                            <DataTableRow>
                                                              <span>{item?.profile?.position}</span>
                                                            </DataTableRow>
                                                            <DataTableRow size="mb">
                                                              <span className="tb-odr-date">{item?.profile?.inserted_at ? moment(item?.profile?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                                            </DataTableRow>
                                                            <DataTableRow size="md">
                                                              <span className="tb-odr-date">{item?.last_login ? moment(item?.last_login).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                                            </DataTableRow>
                                                            <DataTableRow size="md">
                                                              <span className="tb-odr-status">
                                                                <Badge
                                                                  color={
                                                                    item?.profile?.status === app_consts.ACTIVE
                                                                      ? "success"
                                                                      : "danger"
                                                                  }
                                                                  className="badge-dot"
                                                                >
                                                                  {item?.profile?.status?.toUpperCase() || "--"}
                                                                </Badge>
                                                              </span>
                                                            </DataTableRow>
                                                            <DataTableRow className="nk-tb-col-tools">
                                                              <div className="tb-odr-btns d-none d-sm-inline">
                                                                <Link to={`#`}>
                                                                  <Button color="primary" size="sm" className="btn btn-dim">
                                                                    View
                                                                  </Button>
                                                                </Link>
                                                              </div>
                                                              <Button className="btn-pd-auto d-sm-none">
                                                                <Icon name="chevron-right"></Icon>
                                                              </Button>
                                                            </DataTableRow>
                                                          </DataTableItem>
                                                        ))
                                                        : null}
                                                    </div>
                                                  </Block>

                                                  {/* Add Employee Modal */}



                                                  < Modal isOpen={add_employee_modal} className="modal-dialog-centered" size={"lg"} >
                                                    <ModalHeader toggle={add_employee_loading ? "" : close_add_employee_modal}>Add Employee</ModalHeader>
                                                    <ModalBody>
                                                      <Row className="g-4">
                                                        <TextInput
                                                          label="First Name"
                                                          type="text"
                                                          id_val="first_name"
                                                          value={add_employee_formData.first_name}
                                                          colSize="6"
                                                          name="first_name"
                                                          handleChange={handleAddEmployeeChange}
                                                          required
                                                        />
                                                        <TextInput
                                                          label="Last Name"
                                                          type="text"
                                                          id_val="last_name"
                                                          value={add_employee_formData.last_name}
                                                          colSize="6"
                                                          name="last_name"
                                                          handleChange={handleAddEmployeeChange}
                                                          required
                                                        />
                                                        <Col lg="6">
                                                          <div className="form-group">
                                                            <div className="form-label-group">
                                                              <label className="form-label" htmlFor="mobile_number">
                                                                Mobile Number<span className='text-danger pr-2'>{`* `}</span>
                                                              </label>
                                                            </div>
                                                            <div className="form-control-wrap">
                                                              <PhoneInput
                                                                country={"zm"}
                                                                value={add_employee_formData.mobile_number}
                                                                onChange={(phone) => setAddEmployeeFormData({ ...add_employee_formData, ["mobile_number"]: phone })}
                                                                copyNumbersOnly={false}
                                                                inputStyle={{ width: '100%' }}
                                                              />
                                                            </div>
                                                          </div>
                                                        </Col>
                                                        <TextInput
                                                          label="Email Address"
                                                          type="text"
                                                          id_val="email_address"
                                                          value={add_employee_formData.email_address}
                                                          colSize="6"
                                                          name="email_address"
                                                          handleChange={handleAddEmployeeChange}
                                                          required
                                                        />
                                                        <TextInput
                                                          label="Department"
                                                          type="text"
                                                          id_val="department"
                                                          value={add_employee_formData.department}
                                                          colSize="6"
                                                          name="department"
                                                          handleChange={handleAddEmployeeChange}
                                                          required
                                                        />
                                                        <TextInput
                                                          label="Position"
                                                          type="text"
                                                          id_val="position"
                                                          value={add_employee_formData.position}
                                                          colSize="6"
                                                          name="position"
                                                          handleChange={handleAddEmployeeChange}
                                                          required
                                                        />
                                                        {/* Roles */}

                                                        <div className="form-group">
                                                          <label className="form-label">Roles<span className='text-danger pr-2'>{`* `}</span></label>
                                                          <ul className="custom-control-group g-3 align-center">

                                                            {
                                                              tenant_profile_roles && tenant_profile_roles?.length > 0 && tenant_profile_roles?.map((role) => {
                                                                return (
                                                                  <>
                                                                    <li>
                                                                      <div className="custom-control custom-control-sm custom-checkbox">
                                                                        <input onChange={() => handleAddEmployeeRowChange(role)} checked={add_employee_formData?.roles?.includes(role)} type="checkbox" className="custom-control-input" id={role} />
                                                                        <label className="custom-control-label" style={{ fontSize: "18px" }} htmlFor={role}>
                                                                          {formatToSentenceCase(role)}
                                                                        </label>
                                                                      </div>
                                                                    </li>
                                                                  </>
                                                                );
                                                              }
                                                              )}
                                                          </ul>
                                                        </div>
                                                        {add_employee_error && (
                                                          <div className="mb-3 w-100">
                                                            <Alert color="danger" className="alert-icon">
                                                              <Icon name="alert-circle" /> {add_employee_error}{" "}
                                                            </Alert>
                                                          </div>
                                                        )}
                                                        <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                                                          <Button onClick={handleSubmitAddEmployee} disabled={add_employee_loading || !(add_employee_formData?.first_name && add_employee_formData?.last_name && add_employee_formData?.email_address && add_employee_formData?.roles?.length > 0 && add_employee_formData?.position && add_employee_formData?.department && add_employee_formData?.mobile_number)} color="primary">
                                                            {add_employee_loading ? <Spinner size="sm" color="light" /> : "Add Employee"}
                                                          </Button>
                                                        </Col>
                                                      </Row>
                                                    </ModalBody>
                                                  </Modal>
                                                </>
                                                :
                                                <>
                                                  <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Employee Data Found"} />
                                                </>
                                            }
                                          </>
                                      }
                                    </>
                                }
                              </>
                            )
                          }
                          {
                            activeCardTab === "Modules" && (
                              <>
                                <AdminTenantModules tenant_info={tenant_info} user_info={user_info} tenant_id={id} />
                              </>
                            )
                          }
                          {/* {
                            activeCardTab === "Main Info" && (
                              <>
                                <PreviewAltCard>
                                  <Row className="pb-5">
                                    <Col lg={6}>
                                      {
                                        logo_settings?.settings?.logo_url ? (
                                          <>
                                            <Card className="product-card">
                                              <div className="product-thumb">
                                                <img src={logo_settings?.settings?.logo_url} className="card-img-top w-100" alt="Logo" />
                                              </div>
                                            </Card>
                                            <div className="mt-4 d-flex justify-content-end">
                                              <Button color="primary" size="md" onClick={open_upload_logo_modal}>
                                                Update Logo
                                              </Button>
                                            </div>
                                          </>
                                        ) : (
                                          <Card className="product-card" style={{ height: '100%' }}>
                                            <div className="product-thumb" style={{ height: '100%' }}>
                                              <div style={{
                                                width: '100%',
                                                height: '100%',  // Take 100% of the container height
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                backgroundColor: '#f0f0f0', // Light gray background
                                                textAlign: 'center',
                                                border: '1px dashed #ccc', // Dashed border to simulate placeholder
                                                fontSize: '18px', // Font size
                                                fontWeight: 'bold', // Make the text bold
                                                fontFamily: 'Arial, sans-serif', // Custom font
                                                flexDirection: "column"
                                              }}>
                                                <div style={{
                                                  display: 'flex',
                                                  justifyContent: 'center',
                                                  alignItems: 'center',
                                                  textAlign: 'center',
                                                  color: '#333', // Text color
                                                  fontSize: '18px', // Font size
                                                  fontWeight: 'bold', // Make the text bold
                                                  fontFamily: 'Arial, sans-serif', // Custom font
                                                }}>
                                                  <p style={{ margin: 0, padding: '5px' }}>YOUR</p>
                                                  <p style={{ margin: 0, padding: '5px' }}>LOGO</p>
                                                  <p style={{ margin: 0, padding: '5px' }}>HERE</p>
                                                </div>
                                                <Button color="primary" size="md" onClick={open_upload_logo_modal}>
                                                  Upload Logo
                                                </Button>
                                              </div>
                                            </div>
                                          </Card>
                                        )
                                      }
                                    </Col>
                                    <Col lg={6}>
                                      <form className="gy-3 form-settings">
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label" htmlFor="site-name">
                                                Name
                                              </label>
                                              <span className="form-note">Name to be used through out the System</span>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <input disabled type="text" className="form-control" id="site-name" defaultValue={settings?.tenant?.name} />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Website URL</label>
                                              <span className="form-note">URL to Access the System</span>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="site-url"
                                                  defaultValue={`${process.env.PUBLIC_URL}/${settings?.tenant?.url_prefix}`}
                                                  disabled
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Email Address</label>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="site-url"
                                                  defaultValue={settings?.tenant?.email_address}
                                                  disabled
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Mobile Number</label>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="site-url"
                                                  defaultValue={settings?.tenant?.mobile_number}
                                                  disabled
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <div className="mt-4 ">
                                          <BlockHead>
                                            <BlockTitle tag="h6">Contact Details</BlockTitle>
                                          </BlockHead>
                                        </div>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Name</label>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="site-url"
                                                  defaultValue={settings?.user?.first_name ? `${settings?.user?.first_name} ${settings?.user?.last_name}` : "--"}
                                                  disabled
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Email Address</label>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="site-url"
                                                  defaultValue={settings?.account?.email_address || "--"}
                                                  disabled
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Mobile Number</label>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="site-url"
                                                  defaultValue={settings?.account?.mobile_number || "--"}
                                                  disabled
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      </form>
                                    </Col>
                                  </Row>
                                </PreviewAltCard>
                                <Modal isOpen={upload_logo_modal} className="modal-dialog-centered" size={"lg"}>
                                  <ModalHeader toggle={!upload_logo_loading && close_upload_logo_modal}>Upload Logo</ModalHeader>
                                  <ModalBody>
                                    <div className="product-thumb" style={{ height: '250px', width: '100%', position: 'relative' }}>
                                      {formData.tenant_logo ? (
                                        <>
                                          <img
                                            src={URL.createObjectURL(formData.tenant_logo)}
                                            alt="Uploaded Logo"
                                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                          />
                                        </>
                                      ) : (
                                        <label htmlFor="imageUpload" style={{
                                          width: '100%',
                                          height: '100%',
                                          display: 'flex',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          backgroundColor: '#f0f0f0',
                                          textAlign: 'center',
                                          border: '1px dashed #ccc',
                                          fontSize: '18px',
                                          fontWeight: 'bold',
                                          fontFamily: 'Arial, sans-serif',
                                          flexDirection: "column",
                                          cursor: 'pointer'
                                        }}>
                                          <p style={{ margin: 0, padding: '5px' }}>Click to Select Image</p>
                                        </label>
                                      )}

                                      <input
                                        type="file"
                                        id="imageUpload"
                                        accept="image/png, image/jpeg, image/jpg"
                                        style={{ display: 'none' }}
                                        onChange={handleImageUpload}
                                      />
                                    </div>

                                    {upload_logo_error && (
                                      <div className="mb-3 w-100 mt-4">
                                        <Alert color="danger" className="alert-icon">
                                          <Icon name="alert-circle" /> {upload_logo_error}{" "}
                                        </Alert>
                                      </div>
                                    )}
                                    <div className={`d-flex flex-row ${formData?.tenant_logo ? "justify-content-between" : "justify-content-end"} mt-4`}>
                                      {
                                        formData?.tenant_logo && (
                                          <>
                                            <Button color="primary" size="md" onClick={open_upload_logo_modal}>
                                              Re-upload
                                            </Button>
                                          </>
                                        )
                                      }
                                      <Button color="success" size="md" onClick={handle_logo_submit} disabled={!formData?.tenant_logo}>
                                        {upload_logo_loading ? "Uploading Logo..." : "Upload Logo"}
                                      </Button>
                                    </div>
                                  </ModalBody>
                                </Modal>
                              </>
                            )
                          }
                          {
                            activeCardTab === "Integrations" && (
                              <>
                                <Block className='my-3'>
                                  <Row className="g-gs">
                                    <Col xxl="6" key={module.id}>
                                      <div className="nk-download">
                                        <div className="data">
                                          <div className="thumb">
                                            <Icon name="emails" style={{ fontSize: "32px" }} />
                                          </div>
                                          <div className="info">
                                            <h6 className="title">
                                              <span className="name">Emailing Service</span>{" "}
                                            </h6>
                                            <div className="meta">
                                              <span className="version">
                                                <span className="text-soft">Email Provider: </span> <span>{email_provider_settings?.settings?.email_provider || "Not Set"}</span>
                                              </span>
                                              <span className="release">
                                                <span className="text-soft">Email Address: </span> <span>{email_provider_settings?.settings?.email_address || "Not Set"}</span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="actions">
                                          <Button onClick={open_email_provider_modal} color={email_provider_settings?.email_provider ? "Active" : "primary"}>
                                            Update
                                          </Button>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xxl="6" key={module.id}>
                                      <div className="nk-download">
                                        <div className="data">
                                          <div className="thumb">
                                            <Icon name="emails" style={{ fontSize: "32px" }} />
                                          </div>
                                          <div className="info">
                                            <h6 className="title">
                                              <span className="name">Bulk SMS Service</span>{" "}
                                            </h6>
                                            <div className="meta">
                                              <span className="version">
                                                <span className="text-soft">SMS Provider: </span> <span>{sms_provider_formData?.settings?.sms_provider || "Not Set"}</span>
                                              </span>
                                              <span className="release">
                                                <span className="text-soft">Sender ID: </span> <span>{sms_provider_formData?.settings?.sms_sender_id || "Not Set"}</span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="actions">
                                          <Button onClick={open_sms_provider_modal} color={sms_provider_formData?.sms_provider ? "Active" : "primary"}>
                                            Update
                                          </Button>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Block>

                                <Modal isOpen={email_provider_modal} className="modal-dialog-centered" size={"md"}>
                                  <ModalHeader toggle={!email_provider_loading && close_email_provider_modal}>Update Email Provider Settings</ModalHeader>
                                  <ModalBody>
                                    <Row className="g-4">
                                      <TextInput
                                        label="Email Address"
                                        type="email"
                                        required
                                        id_val="email_provider_email_address"
                                        value={email_provider_formData?.email_address}
                                        colSize="6"
                                        name="email_provider_email_address"
                                        handleChange={(e) => setEmailProviderFormData({ ...email_provider_formData, ["email_address"]: e.target.value })}
                                      />
                                      <TextInput
                                        label="Email Provider"
                                        type="text"
                                        required
                                        id_val="email_provider_email_provider"
                                        value={email_provider_formData?.email_provider}
                                        colSize="6"
                                        name="email_provider_email_provider"
                                        handleChange={(e) => setEmailProviderFormData({ ...email_provider_formData, ["email_provider"]: e.target.value })}
                                      />
                                      <TextInput
                                        label="Password"
                                        type="password"
                                        required
                                        id_val="email_provider_password"
                                        value={email_provider_formData?.password}
                                        colSize="6"
                                        name="email_provider_password"
                                        handleChange={(e) => setEmailProviderFormData({ ...email_provider_formData, ["password"]: e.target.value })}
                                      />
                                      {email_provider_error && (
                                        <div className="mb-3 w-100">
                                          <Alert color="danger" className="alert-icon">
                                            <Icon name="alert-circle" /> {email_provider_error}{" "}
                                          </Alert>
                                        </div>
                                      )}
                                      <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                                        <Button
                                          onClick={handleUpdateEmailCredentials}
                                          disabled={email_provider_loading ||
                                            !(email_provider_formData?.email_address?.trim() &&
                                              email_provider_formData?.email_provider?.trim() &&
                                              email_provider_formData?.password?.trim())}
                                          color="primary"
                                        >
                                          {email_provider_loading ? <Spinner size="sm" color="light" /> : "Update Email Credentials"}
                                        </Button>
                                      </Col>
                                    </Row>
                                  </ModalBody>
                                </Modal>

                                <Modal isOpen={sms_provider_modal} className="modal-dialog-centered" size={"md"}>
                                  <ModalHeader toggle={!sms_provider_loading && close_sms_provider_modal}>Update Bulk SMS Provider Settings</ModalHeader>
                                  <ModalBody>
                                    <Row className="g-4">
                                      <TextInput
                                        label="SMS Provider"
                                        type="text"
                                        required
                                        id_val="sms_provider"
                                        value={sms_provider_formData?.sms_provider}
                                        colSize="6"
                                        name="sms_provider"
                                        handleChange={(e) => setSmsProviderFormData({ ...sms_provider_formData, ["sms_provider"]: e.target.value })}
                                      />
                                      <TextInput
                                        label="Sender ID"
                                        type="text"
                                        required
                                        id_val="sms_sender_id"
                                        value={sms_provider_formData?.sms_sender_id}
                                        colSize="6"
                                        name="sms_sender_id"
                                        handleChange={(e) => setSmsProviderFormData({ ...sms_provider_formData, ["sms_sender_id"]: e.target.value })}
                                      />
                                      <TextInput
                                        label="API Key"
                                        type="password"
                                        required
                                        id_val="sender_api_key"
                                        value={sms_provider_formData?.password}
                                        colSize="6"
                                        name="sender_api_key"
                                        handleChange={(e) => setSmsProviderFormData({ ...sms_provider_formData, ["password"]: e.target.value })}
                                      />
                                      {email_provider_error && (
                                        <div className="mb-3 w-100">
                                          <Alert color="danger" className="alert-icon">
                                            <Icon name="alert-circle" /> {email_provider_error}{" "}
                                          </Alert>
                                        </div>
                                      )}
                                      <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                                        <Button
                                          onClick={handleUpdateSmsCredentials}
                                          disabled={sms_provider_loading ||
                                            !(sms_provider_formData?.sms_provider?.trim() &&
                                              sms_provider_formData?.sms_sender_id?.trim() &&
                                              sms_provider_formData?.password?.trim())}
                                          color="primary"
                                        >
                                          {sms_provider_loading ? <Spinner size="sm" color="light" /> : "Update SMS Credentials"}
                                        </Button>
                                      </Col>
                                    </Row>
                                  </ModalBody>
                                </Modal>


                              </>
                            )
                          } */}
                        </>
                        :
                        <>
                          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Details Found"} />
                        </>
                    }
                  </>
              }
            </>
        }
      </Content>
    </>
  );
};

export default AdminTenantDetails;